export default __webpack_public_path__ + "static/media/ic_wcro_16.6119ad6b.svg";